import Dropzone from 'dropzone';

/* eslint-disable lines-between-class-members */
const STATUS_ARCHIVED = 'archived';
const STATUS_FAILURE = 'failure';
const STATUS_RUNNING = 'running';
const STATUS_QUEUED = 'queued';
const STATUS_SUCCESS = 'success';
const STATUS_VALIDATION_FAIL = 'validation_failed';
const STATUS_VALIDATION_PASS = 'ready_to_import';
const STATUS_AWAITING_VALIDATION = 'awaiting_validation';
const DRAG_DROP_TITLE = 'DRAG AND DROP FILE TO UPLOAD';
const DROP_TITLE = 'DROP FILE TO UPLOAD';
const view_name = 'item_import.views.item_import';
const image_import_view = 'item_import.views.image_import';

class ItemImport implements MerchantosItemImport {
  accountID: MerchantosItemImport['accountID'];
  breadcrumbsSet: MerchantosItemImport['breadcrumbsSet'];
  employeeEmail: MerchantosItemImport['employeeEmail'];
  dateFormat: MerchantosItemImport['dateFormat'];
  dropzone: MerchantosItemImport['dropzone'];
  itemImport: MerchantosItemImport['itemImport'];
  itemImportID: MerchantosItemImport['itemImportID'];
  job: MerchantosItemImport['job'];
  jobID: MerchantosItemImport['jobID'];
  expectedImageCount: MerchantosItemImport['expectedImageCount'];

  constructor() {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
    this.accountID = null;
    this.breadcrumbsSet = false;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
    this.employeeEmail = null;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
    this.dateFormat = null;
    this.dropzone = null;
    this.itemImport = null;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
    this.itemImportID = null;
    this.job = null;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
    this.jobID = null;
    this.expectedImageCount = 0;

    const old_onpopstate_fnc = window.onpopstate.bind(window);
    window.onpopstate = (event: PopStateEvent) => {
      const item_import_url_substr = `name=${view_name}`;
      const image_import_url_substr = `name=${image_import_view}`;
      if (window.location.href.indexOf(item_import_url_substr) !== -1) {
        old_onpopstate_fnc(event);
        this._loadPage();
      } else if (window.location.href.indexOf(image_import_url_substr) !== -1) {
        $.when(this._getItemImportObj()).done(() => {
          old_onpopstate_fnc(event);
          this.setExpectedImages();
        });
      } else {
        old_onpopstate_fnc(event);
      }
    };

    $(() =>
      window.merchantos.session.init().done(() => {
        const item_import_url_substr = `name=${view_name}`;
        const image_import_url_substr = `name=${image_import_view}`;
        if (window.location.href.indexOf(item_import_url_substr) !== -1) {
          this._loadPage();
        }
        if (window.location.href.indexOf(image_import_url_substr) !== -1) {
          $.when(this.setExpectedImages()).done(() => {
            if (this.expectedImageCount === 0) {
              this._showImageUploadSuccessScreen();
            }

            this._setBreadcrumbs(true);
          });
        }
      })
    );
  }

  /**
   * Begins import process and shows import in progress screen
   * Alerts user if imports are shut down in case of exessive load
   *
   * @private
   */
  public startImport: MerchantosItemImport['startImport'] = () => {
    const email_input = $('#import-email');
    const email = email_input.val();
    const import_url = this._getImportUrl();

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    if (this._isValidEmail(email)) {
      const jsonData = {
        notifyEmail: email,
      };

      $.when(
        window.lsCloud.startServerJob(
          {
            url: import_url,
            type: 'POST',
            data: JSON.stringify(jsonData),
          },
          false
        )
      ).fail(data => {
        const response = JSON.parse(data.responseText);
        // A little hacky but we need to remove the reference to the file name
        // and line number in the error message.
        // Example: Item Imports has been temporarily deactivated due to excessive load.
        // (/web/cloud/includes/system/disaster_management/ResourceAccessManager.class.php on line 115)
        window.alertUser(response.message.split('(')[0]);
      });

      $('#import-preview').hide();
      this._showRunningImportScreen();
    } else {
      email_input.addClass('invalid');
    }
  };

  /**
   * Loads import view for new import
   *
   * @private
   */
  loadItemImportPageForNewImport: MerchantosItemImport['loadItemImportPageForNewImport'] = () => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    $.when(window.newView('listing', view_name, null)).done(() => this._loadPage());
  };

  /**
   * Loads import page for existing import
   *
   * @private
   */
  loadItemImportPageForExistingImport: MerchantosItemImport['loadItemImportPageForExistingImport'] = item_import_id => {
    $('#item-import').remove();
    this._loadPage(item_import_id);
  };

  /**
   * Loads import page for resource blocked. This should only happen when
   * we decide to turn off item imports.
   *
   * @private
   */
  loadItemImportResourceBlockedPage: MerchantosItemImport['loadItemImportResourceBlockedPage'] = () => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    $.when(window.newView('listing', view_name, null)).done(() => {
      this.itemImport = null;
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
      this.itemImportID = null;
      this._loadResourceBlockedPage();
    });
  };

  /**
   * Cancels the current import in progress
   *
   * @private
   */
  cancelAndDiscard: MerchantosItemImport['cancelAndDiscard'] = () => {
    const open_time = new Date();
    // eslint-disable-next-line no-alert
    const confirmed = confirm('Are you sure you want to delete the import?');
    const close_time = new Date();

    // The user may have clicked "Don't let this window show more
    // popups" on their browser. The only way to detect this is if
    // "confirmed" is set very, very, very quickly. I chose 10ms to
    // give it some leeway.

    // Only redirect when the job status has been updated to
    // "Canceling" or "Canceled"
    if (confirmed || close_time.valueOf() - open_time.valueOf() < 10) {
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      $('#import-items').attr('disabled', true);

      $.when(this._cancelImport()).done(() => {
        const item_import_url_substr = `name=${view_name}`;

        // Only redirect if they're still on the item import page
        if (window.location.href.indexOf(item_import_url_substr) !== -1) {
          window.OpenListing('listing', 'item.listings.item_import_v2', {}, '');
          window.clearParents();

          const inventory_crumb = {
            name: 'inventory',
            title: 'Inventory',
            type: 'ui_tab',
          };

          window.pushParent('view', inventory_crumb);

          this.breadcrumbsSet = true;
        }
      });
    }
  };

  addLabelsToQueueForInventoryItems: MerchantosItemImport['addLabelsToQueueForInventoryItems'] = () => {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | number | null' is not assignable to... Remove this comment to see the full error message
    this.accountID = window.merchantos.session.getSystemCustomerID();
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
    this.itemImportID = this.getItemImportIDFromURL();

    $.when(
      window.lsCloud.startServerJob(
        {
          url: `/API/Account/${this.accountID}/ItemImport/${this.itemImportID}/AddLabels`,
          type: 'POST',
        },
        false
      )
    ).done(() => {
      $('.link.labels').remove();
      this._showWarningBar('Labels added to queue.');
    });
  };

  loadImageImport: MerchantosItemImport['loadImageImport'] = () => {
    $.when(window.newView('listing', image_import_view, this.itemImportID)).done(() =>
      this.setExpectedImages()
    );
  };

  /**
   * Gets Item Import ID from current url
   *
   * @private
   */
  getItemImportIDFromURL: MerchantosItemImport['getItemImportIDFromURL'] = () => {
    const hasValue = (value: any) =>
      typeof value !== 'undefined' && value !== 'undefined' && value !== 'null';
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    return hasValue(id) ? id : null;
  };

  /**
   * Sets number of expected images left to import
   *
   */
  setExpectedImages: MerchantosItemImport['setExpectedImages'] = () => {
    const $deferred = $.Deferred();

    const item_import_wrapper = $('#item-import');

    // Ensure HTML has been loaded, otherwise try again in a bit
    if (item_import_wrapper.length === 0) {
      setTimeout(() => this.setExpectedImages(), 100);
    }

    $.when(this._getExpectedImageObj()).done(() => {
      $('#images-expected').htmlReplace(this.expectedImageCount);
      this._checkImageUsage();
      $deferred.resolve();
    });

    return $deferred;
  };

  /**
   * Starts validation process
   * Show results screen if validation passes
   * Show Error card if validation fails
   *
   */
  validateCSV: MerchantosItemImport['validateCSV'] = () => {
    // Disable actions while validate completes
    this._disableValidateButtons();
    this._disableDropdowns();
    this._setDownloadCSVURL();

    const data = {
      createItems: true,
      updateItems: false,
      matchField: '',
    };

    const behaviour = $("input[name='behaviour-value']").val() as string;
    const matchOn = $("input[name='match-field-value']").val() as string;

    if (behaviour === 'create_update' || behaviour === 'update') {
      if (behaviour === 'update') {
        data.createItems = false;
      }
      data.updateItems = true;
      data.matchField = matchOn;
    }

    $.when(
      window.lsCloud.startServerJob(
        {
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'void' is not assignable to type 'string'.
          url: this._getValidateCSVURL(),
          type: 'POST',
          data: JSON.stringify(data),
        },
        false
      )
    )
      .done(response => {
        this._enableDropdowns();
        const status = response.ItemImport.status;

        if (status === STATUS_VALIDATION_PASS) {
          // Since status is now ready_for_import, reload will bring
          // user to import preview page
          location.reload();
        }

        if (status === STATUS_VALIDATION_FAIL) {
          const totalErrors = response.ItemImport.statistics.totalErrors;
          this._showErrorCard(totalErrors);
          this._restartValidation();
          this._showErrorState();
          $('.pre-upload').show();
          $('.post-upload').hide();
          $('#check-import-data').prop('disabled', true);
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
          this._initDropzone(this._getUploadCSVUrl());
        }
      })
      .fail(response => {
        const failResponse = JSON.parse(response.responseText);
        // A little hacky but we need to remove the reference to the file name
        // and line number in the error message.
        // Example: Item Imports has been temporarily deactivated due to excessive load. (/web/cloud/includes/system/disaster_management/ResourceAccessManager.class.php on line 115)
        window.alertUser(failResponse.message.split('(')[0]);
        this._restartValidation();
        this._showErrorState();
      });
  };

  /**
   * Shows initial upload csv state
   * Resets dropzone with url to reupload csv to current job
   * Enables import type dropdowns
   *
   */
  restartUpload: MerchantosItemImport['restartUpload'] = () => {
    this._showUploadState();
    this._resetDropzone();
    this._updateDropzoneTitle(DRAG_DROP_TITLE);
    this._enableDropdowns();
  };

  /* ---------------------*
   *  Private functions  *
   *---------------------*/

  /**
   * Sets ItemImportID and ItemImport object before loading UI
   *
   * @private
   * @param {number} item_import_id for the current import.
   */
  _loadPage: MerchantosItemImport['_loadPage'] = item_import_id => {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | number | null' is not assignable to... Remove this comment to see the full error message
    this.accountID = window.merchantos.session.getSystemCustomerID();

    // Reset data from previous import
    this.itemImport = null;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
    this.itemImportID = null;
    if (typeof item_import_id !== 'undefined') {
      this.itemImportID = item_import_id;
    }

    $.when(this._getItemImportObj()).done(() => this._loadUI());
  };

  /**
   * Loads template based on current import status
   * Loads validation screen if no import is set
   *
   * @private
   */
  _loadUI: MerchantosItemImport['_loadUI'] = () => {
    // We're not looking at a specific ID; show the validation screen
    if (!this.itemImport) {
      $.when(this._setTemplateCSVURL()).done(() => {
        this._setBreadcrumbs(false);
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
        this._initDropzone(this._getCreateUrl());
        $('#item-import-placeholder').hide();
        $('#item-import-validate').show();
      });
    } else {
      this._setDownloadCSVURL();

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      // eslint-disable-next-line default-case
      switch (this.itemImport.status) {
        case STATUS_RUNNING:
          this._showRunningImportScreen();
          break;

        case STATUS_SUCCESS:
        case STATUS_FAILURE:
          this._showResultsScreen();
          break;

        case STATUS_VALIDATION_FAIL:
          this._showValidationFailScreen();
          break;

        case STATUS_AWAITING_VALIDATION:
          this._showAwaitingValidationScreen();
          break;

        case STATUS_VALIDATION_PASS:
          this._showValidationPassScreen();
          break;

        case STATUS_QUEUED:
          this._showQueuedImportScreen();
          break;
      }
    }
  };

  _showAwaitingValidationScreen: MerchantosItemImport['_showAwaitingValidationScreen'] = () => {
    // Ensure HTML has been loaded, otherwise try again in a bit
    const item_import_validate_wrapper = $('#item-import-validate');
    if (item_import_validate_wrapper.length === 0) {
      setTimeout(() => this._showAwaitingValidationScreen(), 100);

      return;
    }

    this._setBreadcrumbs(false);

    // We're doing funky stuff onload; the top-right navigation breaks it,
    // so disable it
    $('nav.records').hide();
    $('#item-import-placeholder').hide();

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
    this._initDropzone(this._getUploadCSVUrl());

    this._showValidateState();

    item_import_validate_wrapper.show();
  };

  /**
   * Shows Validation Failed Screen
   * Changes cancel button to cancel and discard
   * Shows error card including error/suggested fix CSV
   *
   * @private
   */
  _showValidationFailScreen: MerchantosItemImport['_showValidationFailScreen'] = () => {
    // Ensure HTML has been loaded, otherwise try again in a bit
    const item_import_validate_wrapper = $('#item-import-validate');
    if (item_import_validate_wrapper.length === 0) {
      setTimeout(() => this._showValidationFailScreen(), 100);

      return;
    }

    this._updateCSVPreviewData();

    this._setBreadcrumbs(false);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    const totalErrors = this.itemImport.statistics.totalErrors;
    this._showErrorCard(totalErrors);
    this._showValidationFailState();

    // We're doing funky stuff onload; the top-right navigation breaks it,
    // so disable it
    $('nav.records').hide();

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
    this._initDropzone(this._getUploadCSVUrl());
    this._restartValidation();

    item_import_validate_wrapper.show();
  };

  /**
   * Resets state to before validation began
   * Shows number of errors in invalid csv
   * Provides link to download error csv
   *
   * @private
   */
  _showValidationFailState: MerchantosItemImport['_showValidationFailState'] = () => {
    $('.validate-container').hide();
    $('.pre-upload').show();
    $('.post-upload').hide();
    const cancelButton = $('#cancel-import-validate');
    cancelButton.htmlReplace('Cancel & Discard');
    cancelButton.addClass('-danger');
    $('#item-import-placeholder').hide();
    $('#check-import-data').htmlReplace('Continue');
    $('#validate-button').htmlReplace('Continue');
  };

  /**
   * Shows Validation Passed Screen
   * Displays item import statistics
   *
   * @private
   */
  _showValidationPassScreen: MerchantosItemImport['_showValidationPassScreen'] = () => {
    $.when(window.merchantos.session.getEcomIntegration(), this._getEmployeeEmail()).done(() => {
      this._setBreadcrumbs(false);

      this._updatePreviewStatistics(this.itemImport);

      if (window.merchantos.session.ecomIntegration) {
        $('#import-preview-online-price').show();
      }

      $('#import-email').val(this.employeeEmail);
      $('#item-import-placeholder').hide();
      $('#import-preview').show();
    });
  };

  /**
   * Shows Queued Import Screen
   * Checks Queue status to update screen to in progress once import is ready
   *
   * @private
   */
  _showQueuedImportScreen: MerchantosItemImport['_showQueuedImportScreen'] = () => {
    this._setBreadcrumbs(false);
    this._checkImportQueue();
    this._setImportTitle(
      'Import Queued',
      'The import will be processed soon. You can safely navigate away from this page.'
    );
    $('#import-in-progress-bar-text').htmlReplace('Import Queued');
    $('#import-in-progress-status-bar').css('width', '3%');
    $('#item-import-placeholder').hide();
    $('#import-in-progress').show();
  };

  /**
   * Shows Running Import Screen
   * Initializes progress bar to 3% so import doesnt sit at 0%
   *
   * @private
   */
  _showRunningImportScreen: MerchantosItemImport['_showRunningImportScreen'] = () => {
    this._setBreadcrumbs(false);
    this._setImportTitle(
      'Import in Progress',
      'The import is running. You can safely navigate away from this page.'
    );
    $('#import-in-progress-bar-text').htmlReplace('3%');
    $('#import-in-progress-status-bar').css('width', '3%');
    this._updateProgressBar();
    $('#import-in-progress > .retail-action-bar').hide();
    $('#item-import-placeholder').hide();
    $('#import-in-progress').show();
  };

  /**
   * Shows Import Results Screen
   * Updates screen with all statistics of the import
   *
   * @private
   */
  _showResultsScreen: MerchantosItemImport['_showResultsScreen'] = () => {
    const import_results_wrapper = $('#import-results');

    // Ensure HTML has been loaded, otherwise try again in a bit
    if (import_results_wrapper.length === 0) {
      setTimeout(() => this._showResultsScreen(), 100);

      return;
    }

    this._setBreadcrumbs(false);
    const wrapper = $('.import-report .row');
    const statWrapper = $('.import-statistics');

    $.when(
      window.lsCloud.startServerJob(
        {
          url: `API/Account/${this.accountID}/Employee.json`,
          type: 'GET',
        },
        false
      ),
      this._getDateFormat(),
      this._getJobObj()
    ).done(data => {
      let employees: unknown = data.Employee;

      if (!Array.isArray(employees)) {
        employees = [employees];
      }

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      employees.forEach(employee => {
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        if (employee.employeeID === this.job.employeeID) {
          let firstName = '';
          let lastName = '';

          if (typeof employee.firstName !== 'undefined') {
            firstName = employee.firstName;
          }

          if (typeof employee.lastName !== 'undefined') {
            lastName = employee.lastName;
          }

          wrapper.find('.employee-name').htmlReplace(`${firstName} ${lastName}`);
        }
      });

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      wrapper.find('.filename').htmlReplace(this.itemImport.filename);

      wrapper
        .find('.date-started')
        // @ts-expect-error ts-migrate(2686) FIXME: 'moment' refers to a UMD global, but the current f... Remove this comment to see the full error message
        .htmlReplace(moment(this.job.createTime).format(this.dateFormat));

      wrapper
        .find('.date-completed')
        // @ts-expect-error ts-migrate(2686) FIXME: 'moment' refers to a UMD global, but the current f... Remove this comment to see the full error message
        .htmlReplace(moment(this.job.timeStamp).format(this.dateFormat));

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      if (this.itemImport.status === STATUS_FAILURE) {
        $('.import-statistics').hide();
        $('.import-report.error').show();
        wrapper.find('.status.failed').show();
      } else {
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        const totalNewItems = this.itemImport.statistics.totalNewItems;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        const totalUpdatedItems = this.itemImport.statistics.totalUpdatedItems;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        const totalVendors = this.itemImport.statistics.totalNewManufacturers;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        const totalManufacturers = this.itemImport.statistics.totalNewVendors;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        const totalCategories = this.itemImport.statistics.totalNewCategories;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        const totalQuantity = this.itemImport.statistics.totalQuantity;

        if (parseInt(totalQuantity, 10) > 0) {
          $('.link.labels').show();
        }

        if (parseInt(totalNewItems, 10) === 1) {
          statWrapper.find('.new-products span').htmlReplace('Item Created');
        }

        if (parseInt(totalUpdatedItems, 10) === 1) {
          statWrapper.find('.updated-products span').htmlReplace('Item Updated');
        }

        if (parseInt(totalVendors, 10) === 1) {
          statWrapper.find('.vendors span').htmlReplace('New Vendor');
        }

        if (parseInt(totalManufacturers, 10) === 1) {
          statWrapper.find('.manufacturers span').htmlReplace('New Manufacturer');
        }

        if (parseInt(totalCategories, 10) === 1) {
          statWrapper.find('.categories span').htmlReplace('New Category');
        }

        wrapper.find('.status.done').show();
        statWrapper.find('.new-products h3').htmlReplace(totalNewItems);
        statWrapper.find('.updated-products h3').htmlReplace(totalUpdatedItems);
        statWrapper.find('.manufacturers h3').htmlReplace(totalVendors);
        statWrapper.find('.vendors h3').htmlReplace(totalManufacturers);
        statWrapper.find('.categories h3').htmlReplace(totalCategories);
        statWrapper.find('.total-quantity h3').htmlReplace(totalQuantity);
      }

      $.when(this.setExpectedImages()).done(() => {
        const totalImages = this.expectedImageCount;

        const pluralizeImage = totalImages === 1 ? ' image' : ' images';

        if (totalImages > 0) {
          const moreActionsWrapper = $('.more-actions .img-link');
          const expectedImgText = `Upload images for these items (<var>${totalImages}</var>${pluralizeImage} expected)`;

          moreActionsWrapper.removeClass('hidden');
          moreActionsWrapper.find('a').htmlReplace(expectedImgText);
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        } else if (this.itemImport.status === STATUS_FAILURE) {
          $('#import-results .page-content .more-actions').addClass('failed');
        }

        // We're doing funky stuff onload; the top-right navigation breaks it,
        // so disable it
        $('nav.records').hide();

        $('#import-in-progress').hide();
        $('#item-import-placeholder').hide();

        import_results_wrapper.show();
      });
    });
  };

  /**
   * Displays the simple screen with text for when we turn off Item Imports.
   * @private
   */
  _loadResourceBlockedPage: MerchantosItemImport['_loadResourceBlockedPage'] = () => {
    $('#item-import-placeholder').hide();
    $('#item-import-resource-blocked').show();
  };

  /**
   * Initialized dropzone for user to provide import CSV
   * Adds functionality to various dropzone events
   *
   * @param {String} url for API to valdiate CSV
   * @private
   */
  _initDropzone: MerchantosItemImport['_initDropzone'] = url => {
    let dragStatus = 0;
    let numFiles = 0;
    const self = this;
    this.dropzone = new Dropzone('#item-import-dropzone', {
      url,
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
      },
      maxFiles: 1,
      acceptedFiles: [
        '.csv',
        'text/csv',
        '.xls',
        'application/vnd.ms-excel',
        '.xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].join(', '),
      clickable: '#browse',
      init() {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hiddenFileInput' does not exist on type ... Remove this comment to see the full error message
        this.hiddenFileInput.removeAttribute('multiple');

        self._setDownloadCSVURL();

        this.on('addedfile', function onAddedfile(file) {
          if (self.itemImportID) {
            // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            this.options.url = self._getUploadCSVUrl();
          }

          numFiles++;
          if (numFiles > 1) {
            self._showErrorBar('Only 1 file can be uploaded at a time.');
            self._restartValidation();
            dragStatus = 0;
            numFiles = 0;
            // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            this.dropzone.removeAllFiles(true);
            // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            this.dropzone.cancelUpload(file);
          }
        });
      },
      sending() {
        numFiles = 0;
        $('#item-import-dropzone').removeClass('highlight');

        self._disableDropdowns();

        // trigger progress bar
        self._startCSVUpload();
      },
      // @ts-expect-error ts-migrate(2322) FIXME: Type '(_file: any, response: any) => void' is not ... Remove this comment to see the full error message
      success(_file, response) {
        // handle response
        if (response.ItemImport.status === STATUS_AWAITING_VALIDATION) {
          if (!self.itemImport) {
            self.itemImportID = response.ItemImport.itemImportID;
            self.jobID = response.ItemImport.jobID;
            window.history.pushState(
              null,
              // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
              null,
              `/?name=item_import.views.item_import&form_name=view&id=${self.itemImportID}&tab=details`
            );
          }

          self.itemImport = response.ItemImport;
        }

        self._showValidateState();
      },
      dragenter(event) {
        event.preventDefault(); // needed for IE
        dragStatus++;
        // Reset to 0 after incorrect upload
        numFiles = 0;
        // drag inside dropzone
        if (dragStatus === 1) {
          self._updateDropzoneTitle(DROP_TITLE);
          $('#item-import-dropzone').addClass('highlight');
          $('.upload-csv-text').hide();
        }
      },
      error(_file, errorMessage) {
        if (errorMessage === "You can't upload files of this type.") {
          numFiles = 0;
          dragStatus = 0;
          self._showErrorBar('Only CSV, XLS, and XLSX files are supported for the import.');
          self._restartValidation();
          self._showCSVTemplateCard();
        }

        if (self.itemImportID) {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'Dropzon... Remove this comment to see the full error message
          this.options.url = self._getUploadCSVUrl();
        }

        $('#item-import-dropzone').removeClass('highlight');

        errorMessage = JSON.parse(JSON.stringify(errorMessage));
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'message' does not exist on type 'string ... Remove this comment to see the full error message
        let error = errorMessage.message;
        // removes error file location from message
        error = error.slice(0, error.indexOf('(/')).trim();

        dragStatus = 0;

        self._showErrorBar(error);
        self._restartValidation();
        self._showCSVTemplateCard();
      },
      dragleave() {
        dragStatus--;
        // drag outside dropzone
        if (dragStatus === 0) {
          self._updateDropzoneTitle(DRAG_DROP_TITLE);
          $('#item-import-dropzone').removeClass('highlight');
          $('.upload-csv-text').show();
        }
      },
      previewTemplate:
        '<div class="dz-preview dz-file-preview">\n  <div class="dz-details">\n    <div class="dz-filename"><span data-dz-name notranslate></span></div>\n    <div class="dz-size" data-dz-size notranslate></div>\n    <img data-dz-thumbnail />\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-success-mark"><span>✔</span></div>\n  <div class="dz-error-mark"><span>✘</span></div>\n  <div class="dz-error-message"><span data-dz-errormessage notranslate></span></div>\n</div>',
    });
    window.blockDropzoneFilesizeTranslation();

    // Without this, the dropzone image is a valid thing to drop in
    $('#dropzone-img').on('dragstart', event => event.preventDefault());
  };

  _resetDropzone: MerchantosItemImport['_resetDropzone'] = () => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.dropzone.destroy();
    this.dropzone = null;
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
    this._initDropzone(this._getUploadCSVUrl());
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.dropzone.enable();
  };

  /**
   * Updates title of dropzone
   *
   * @param {String} title for dropzone
   * @private
   */
  _updateDropzoneTitle: MerchantosItemImport['_updateDropzoneTitle'] = title => {
    $('.upload-csv-title span').show();
    $('.upload-csv-title span').htmlReplace(title);
  };

  /**
   * Sets correct CSV template based on whether or not user has ecom activated
   *
   * @private
   */
  _setTemplateCSVURL: MerchantosItemImport['_setTemplateCSVURL'] = () => {
    const $deferred = $.Deferred();

    $.when(window.merchantos.session.getEcomIntegration()).done(() =>
      $.when(
        window.lsCloud.startServerJob(
          {
            url: `/API/Account/${this.accountID}/ItemImport/Template`,
            type: 'GET',
          },
          false
        )
      )
        .done(data => {
          $('#download-template').attr(
            'href',
            `data:text/plain;charset=utf-8,${encodeURIComponent(data)}`
          );
          $('#download-template').attr('download', 'item_import_sample.csv');
          $deferred.resolve();
        })
        .fail(() => {
          $('#item-import-placeholder').hide();
          $('#item-import-resource-blocked').show();
          this._setBreadcrumbs(false);
        })
    );

    return $deferred;
  };

  /**
   * Sets URL to download original CSV used for import
   *
   * @private
   */
  _setDownloadCSVURL: MerchantosItemImport['_setDownloadCSVURL'] = () => {
    if (this.itemImportID) {
      const accountID = window.merchantos.session.getSystemCustomerID();
      const url = `window.merchantos.utils.openUrl('API/Account/${accountID}/ItemImport/${this.itemImportID}/CSV', '_blank');`;
      $('.csv-download').attr('onclick', url);
    }
  };

  /**
   * Resets state to intiial upload state
   *
   * @private
   */
  _showUploadState: MerchantosItemImport['_showUploadState'] = () => {
    $('.-tutorial').show();
    $('.validate-container').hide();
    $('.pre-upload').show();
    $('.post-upload').hide();
    $('#check-import-data').prop('disabled', true);
    $('.progress-bar .bar').width('0%');
    $('.progress-bar').hide();
    $('.upload-csv-text').show();
    this._showCSVTemplateCard();
    this._setDropzoneBorder();
  };

  /**
   * Sets border of dropzone for upload state
   *
   * @private
   */
  _setDropzoneBorder: MerchantosItemImport['_setDropzoneBorder'] = () => {
    $('.dropzone-container').css('border', 'dashed 2px #C4CACC');
    $('.dropdown-container').css('border-radius', '3px');
  };

  /**
   * Sets border of dropzone for upload state
   *
   * @private
   */
  _setValidateBorder: MerchantosItemImport['_setValidateBorder'] = () => {
    $('.dropzone-container').css('border', 'solid 1px #C4CACC');
    $('.dropdown-container').css('border-radius', '3px 3px 0 0');
  };

  /**
   * Calls employee endpoint to get current employee email
   * To be used for receiving an email once import is complete
   *
   * @private
   */
  _getEmployeeEmail: MerchantosItemImport['_getEmployeeEmail'] = () => {
    const $deferred = $.Deferred();
    const employee = window.merchantos.session.getEmployee();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const employee_id = employee.employeeID;

    window.lsCloud
      .getJSONFromAPI(
        `/API/Account/${window.merchantos.session.getSystemCustomerID()}/Employee/${employee_id}?load_relations=["Contact"]`
      )
      .then(data => {
        let contact_emails = data?.Employee?.Contact?.Emails?.ContactEmail;
        if (!Array.isArray(contact_emails)) {
          contact_emails = [contact_emails];
        }

        this.employeeEmail = contact_emails[0]?.address ?? this.employeeEmail;

        $deferred.resolve();
      });

    return $deferred;
  };

  _disableDropdowns: MerchantosItemImport['_disableDropdowns'] = () => {
    $('.import-type-dropdown h3').css({ opacity: 0.5 });
    $('#behaviour-dropdown').prop('disabled', true);
    $('#match-field-dropdown').prop('disabled', true);
  };

  _enableDropdowns: MerchantosItemImport['_enableDropdowns'] = () => {
    $('.import-type-dropdown h3').css({ opacity: 1 });
    $('#behaviour-dropdown').prop('disabled', false);
    $('#match-field-dropdown').prop('disabled', false);
  };

  /**
   * Sets gui_defs breadcrumbs
   * Called every time breadcrumbs need to be updated
   *
   * @private
   */
  _setBreadcrumbs: MerchantosItemImport['_setBreadcrumbs'] = image => {
    $.when(this._getItemImportObj()).done(() => {
      if (!this.breadcrumbsSet) {
        window.clearParents();

        const inventory_crumb = {
          name: 'inventory',
          title: 'Inventory',
          type: 'ui_tab',
        };

        const imports_crumb = {
          name: 'item.listings.item_import_v2',
          title: 'Item Imports',
          type: 'listing',
        };

        window.pushParent('view', inventory_crumb);
        window.pushParent('listing', imports_crumb);

        $.when(this._getJobObj()).done(() => {
          if (image) {
            const results_crumb = {
              name: 'item_import.views.item_import',
              // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
              title: `Item Import: Import of ${this.job.name}`,
              type: 'view',
              record_id: this.itemImportID,
            };

            window.pushParent('view', results_crumb);
          }

          const current = window.createParent('view');
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | Partial<{ id: string; ... Remove this comment to see the full error message
          window.pushParent('view', current);

          this.breadcrumbsSet = true;
        });
      }
    });
  };

  _checkImageUsage: MerchantosItemImport['_checkImageUsage'] = () => {
    $.when(window.merchantos.session.getImageUsage()).done(() => {
      const imagesWrapper = $('#import-images');
      const imageUsage = window.merchantos.session.imageUsage;
      let limitString = '';

      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      if (imageUsage.Usage.imageCountHardLimitReached == 'true') {
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        const imageLimit = imageUsage.Usage.defaultMaxImageCount;
        limitString = `<var>${imageLimit}</var> of <var>${imageLimit}</var> images used. Image upload disabled.`;

        imagesWrapper.find('.js-add-images-button').remove();
        imagesWrapper.find('.image-limit span').htmlReplace(limitString);

        imagesWrapper.find('.image-limit').show();
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      } else if (imageUsage.Usage.totalImageSizeHardLimitReached == 'true') {
        limitString = 'Image storage limit reached. Image upload disabled.';

        imagesWrapper.find('.js-add-images-button').remove();
        imagesWrapper.find('.image-limit span').htmlReplace(limitString);

        imagesWrapper.find('.image-limit').show();
      } else {
        imagesWrapper.find('.js-add-images-button').show();
      }
    });
  };

  _updateProgressBar: MerchantosItemImport['_updateProgressBar'] = () => {
    const url = `API/Account/${window.merchantos.session.getSystemCustomerID()}/Job/${this.jobID}`;
    window.lsCloud.getJSONFromAPI(url).done(data => {
      const job_data = data.Job;

      const progress = Math.ceil(
        (parseInt(job_data.completedWork, 10) * 100) / parseInt(job_data.totalWork, 10)
      );

      // Only start updating progress bar after 3 percent
      // so that progress doesn't move backwards from default
      // starting point
      if (progress > 3) {
        $('#import-in-progress-status-bar').css('width', `${progress}%`);
        $('#import-in-progress-bar-text').htmlReplace(`${progress}%`);
      }

      if (job_data.status === STATUS_QUEUED) {
        this._showQueuedImportScreen();
      } else if (job_data.status === STATUS_RUNNING || job_data.status === STATUS_VALIDATION_PASS) {
        window.setTimeout(this._updateProgressBar, 1000);
      } else {
        // Refresh to load Results screen
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    });
  };

  /**
   * Gets date format based on current locale
   *
   * @private
   */
  // @ts-expect-error ts-migrate(2322) FIXME: Type '() => JQuery.Deferred<any, any, any> | undef... Remove this comment to see the full error message
  _getDateFormat: MerchantosItemImport['_getDateFormat'] = () => {
    if (this.dateFormat) {
      return;
    }

    const $deferred = $.Deferred();

    window.lsCloud.Options.get('date_format').done(value => {
      if (!value || parseInt(value, 10) === 0) {
        value = window.merchantos.locale.date_format;
      }

      value = value.replace('m', 'M');
      value = value.replace('d', 'D');
      value += ' hh:mm:ss A';

      this.dateFormat = value;

      $deferred.resolve();
    });

    return $deferred;
  };

  _disableValidateButtons: MerchantosItemImport['_disableValidateButtons'] = () => {
    $('#check-import-data').htmlReplace('Validating...');
    $('#validate-button').htmlReplace('Validating...');
    $('#check-import-data').prop('disabled', true);
    $('#validate-button').prop('disabled', true);
  };

  /**
   * Checks if inputed email is valid
   *
   * @param {String} email provided by user
   * @private
   */
  _isValidEmail: MerchantosItemImport['_isValidEmail'] = email => {
    let ret = true;
    if (email.length > 0 && !window.isEmail(email)) {
      $('.validation-failure').show();
      ret = false;
    }
    return ret;
  };

  /**
   * Sets title of import currently in progress
   *
   * @param {String} title for page
   * @param {String} message subtitle for page
   * @private
   */
  _setImportTitle: MerchantosItemImport['_setImportTitle'] = (title, message) => {
    $('#import-in-progress-title').htmlReplace(title);
    $('#import-in-progress-text').htmlReplace(message);
  };

  /**
   * Show error bar with specified message
   *
   * @param {String} msg for current alert
   * @private
   */
  _showErrorBar: MerchantosItemImport['_showErrorBar'] = msg => {
    $('.alert-warning').show();
    $('.alert-warning_inner').htmlReplace(msg);
  };

  /**
   * Show warning bar with specified message
   *
   * @param {String} msg for current warning
   * @private
   */
  _showWarningBar: MerchantosItemImport['_showWarningBar'] = msg => {
    $('.alert-messages').show();
    $('.alert-messages_inner').htmlReplace(msg);
  };

  /**
   * Begins upload process
   * Updates progress bar to 100%
   * Updates button to discard import
   *
   * @private
   */
  _startCSVUpload: MerchantosItemImport['_startCSVUpload'] = () => {
    $('.upload-csv-text').hide();
    $('.alert-warning').hide();
    $('.progress-bar').show();
    this._updateDropzoneTitle('UPLOADING');
    $('.progress-bar .bar').width('100%');
    $('.dz-input').hide();
  };

  /**
   * Restarts upload progress
   * Updates progress bar to 0%
   *
   * @private
   */
  _restartValidation: MerchantosItemImport['_restartValidation'] = () => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.dropzone.removeAllFiles();
    $('.progress-bar .bar').width('0%');
    this._updateDropzoneTitle(DRAG_DROP_TITLE);
    $('.progress-bar').hide();
    $('.upload-csv-text').show();
    this._enableDropdowns();
  };

  /**
   * Shows Errors Card with total number of errors
   *
   * @param {number} totalErrors in the provided CSV
   * @private
   */
  _showErrorCard: MerchantosItemImport['_showErrorCard'] = totalErrors => {
    $('.template').hide();
    $('.errors').show();
    $('#item-import-validate')
      .find('.page-content')
      .find('.title')
      .htmlReplace('FIX ERRORS & RE-UPLOAD')
      .siblings('.subtitle')
      .htmlReplace('Once all errors are fixed you can proceed to import items.');
    $('#check-import-data').prop('disabled', true);
    $('.errors .count h3').htmlReplace(totalErrors);

    if (totalErrors === '1') {
      $('.errors .count span').htmlReplace('Item With Errors To Fix');
    } else {
      $('.errors .count span').htmlReplace('Items With Errors To Fix');
    }
  };

  _showValidateState: MerchantosItemImport['_showValidateState'] = () => {
    this._updateCSVPreviewData();

    $('#item-import-validate')
      .find('.page-content')
      .find('.title')
      .htmlReplace('SELECT FILE')
      .siblings('.subtitle')
      .htmlReplace(
        'The file must be in CSV, XLS, or XLSX format and may contain up to 1000 items.'
      );
    $('.-tutorial').hide();
    $('.validate-container').show();
    $('.pre-upload').hide();
    $('.post-upload').show();
    $('#check-import-data').prop('disabled', false);
    $('#validate-button').prop('disabled', false);
    this._setValidateBorder();
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    this.dropzone.disable();
    const cancelButton = $('#cancel-import-validate');
    cancelButton.htmlReplace('Cancel & Discard');
    cancelButton.addClass('-danger');
    this._enableDropdowns();
  };

  _showErrorState: MerchantosItemImport['_showErrorState'] = () => {
    $('.validate-container').hide();
    $('.errors').show();
    $('#check-import-data').htmlReplace('Continue');
    $('#validate-button').htmlReplace('Continue');
    this._setDropzoneBorder();
  };

  _updateCSVPreviewData: MerchantosItemImport['_updateCSVPreviewData'] = () => {
    if (this.itemImport) {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      $('.post-upload h3').htmlReplace(this.itemImport.filename);
      $('.post-upload .subtitle').htmlReplace(
        `<var>${
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          this.itemImport.statistics.totalItems
        }</var> items`
      );

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      if (this.itemImport.mimeType) {
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        // eslint-disable-next-line no-useless-escape
        const iconId = `#file-icon-${this.itemImport.mimeType.replace(/[\/.]/g, '-')}`;
        $('.post-upload .upload-file-icon').hide();
        $(iconId).show();
      }
    }
  };

  /**
   * Shows card with template CSV
   *
   * @private
   */
  _showCSVTemplateCard: MerchantosItemImport['_showCSVTemplateCard'] = () => {
    $('.errors').hide();
    $('.template').show();
  };

  /**
   * Gets URL for updating CSV of current import
   *
   * @private
   */
  _getUploadCSVUrl: MerchantosItemImport['_getUploadCSVUrl'] = () => {
    return `/API/Account/${this.accountID}/ItemImport/${this.itemImportID}/CSV.json`;
  };

  /**
   * Gets URL for creating a new import
   *
   * @private
   */
  _getCreateUrl: MerchantosItemImport['_getCreateUrl'] = () => {
    return `/API/Account/${this.accountID}/ItemImport.json`;
  };

  /**
   * Gets URL for validating the current import csv
   *
   * @private
   */
  _getValidateCSVURL: MerchantosItemImport['_getValidateCSVURL'] = () => {
    return `/API/Account/${this.accountID}/ItemImport/${this.itemImportID}/Validate.json`;
  };

  /**
   * Gets URL for import endpoint
   *
   * @private
   */
  _getImportUrl = () => {
    return `/API/Account/${this.accountID}/ItemImport/${this.itemImportID}/Import.json`;
  };

  /**
   * Updates import preview screen with first row of provided csv after
   * validation
   *
   * @param {JSON} response from validation
   * @private
   */
  _updatePreviewStatistics: MerchantosItemImport['_updatePreviewStatistics'] = itemImport => {
    const wrapper = $('#import-preview');

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (parseInt(itemImport.statistics.totalNewItems, 10) === 1) {
      wrapper.find('.new-products span').htmlReplace('New Item');
    }

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (parseInt(itemImport.statistics.totalUpdatedItems, 10) === 1) {
      wrapper.find('.updated-products span').htmlReplace('Updated Item');
    }

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (parseInt(itemImport.statistics.totalNewVendors, 10) === 1) {
      wrapper.find('.vendors span').htmlReplace('New Vendor');
    }

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (parseInt(itemImport.statistics.totalNewManufacturers, 10) === 1) {
      wrapper.find('.manufacturers span').htmlReplace('New Manufacturer');
    }

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (parseInt(itemImport.statistics.totalNewCategories, 10) === 1) {
      wrapper.find('.categories span').htmlReplace('New Category');
    }

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (parseInt(itemImport.statistics.itemsWithInventory, 10) === 1) {
      wrapper.find('.items-quantity span').htmlReplace('New Item With Inventory');
    }

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.new-products h3').htmlReplace(itemImport.statistics.totalNewItems);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.updated-products h3').htmlReplace(itemImport.statistics.totalUpdatedItems);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.vendors h3').htmlReplace(itemImport.statistics.totalNewVendors);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.manufacturers h3').htmlReplace(itemImport.statistics.totalNewManufacturers);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.categories h3').htmlReplace(itemImport.statistics.totalNewCategories);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.total-quantity h3').htmlReplace(itemImport.statistics.totalQuantity);
    wrapper
      .find('.total-cost h3')
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      .htmlReplace(window.merchantos.locale.currency_symbol + itemImport.statistics.totalCost);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    wrapper.find('.items-quantity h3').htmlReplace(itemImport.statistics.itemsWithInventory);

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    const preview_row = itemImport.previewData.ItemImportDataRow;

    if (typeof preview_row !== 'undefined') {
      $("input[name='description']").val(
        $('<div>')
          .html(preview_row.Description)
          .text()
      );

      $("input[name='upc']").val(preview_row.UPC);
      $("input[name='ean']").val(preview_row.EAN);

      // create a in-memory div, set it's inner text(which jQuery automatically encodes)
      // then grab the encoded contents back out.  The div never exists on the page.
      $("input[name='custom-sku']").val(
        $('<div>')
          .html(preview_row.CustomSKU)
          .text()
      );
      $("input[name='manufacturer-sku']").val(
        $('<div>')
          .html(preview_row.ManufacturerSKU)
          .text()
      );

      $("input[name='vendor']").val(
        $('<div>')
          .html(preview_row.Vendor)
          .text()
      );
      $("input[name='vendor-id']").val(
        $('<div>')
          .html(preview_row.VendorID)
          .text()
      );
      $("input[name='manufacturer']").val(
        $('<div>')
          .html(preview_row.Brand)
          .text()
      );
      $("input[name='categories']").val(
        $('<div>')
          .html(this._categoryToDisplayableString(preview_row))
          .text()
      );

      const price_level_data = this._generatePriceLevelMarkup(preview_row.PriceData.PriceLevel);

      $('#price-level-data').append(price_level_data);

      $("input[name='default-cost']").val(preview_row.DefaultCost);

      // @ts-expect-error ts-migrate(7034) FIXME: Variable 'inventory_data' implicitly has type 'any... Remove this comment to see the full error message
      const inventory_data = [];
      // @ts-expect-error ts-migrate(7034) FIXME: Variable 'reorder_data' implicitly has type 'any[]... Remove this comment to see the full error message
      const reorder_data = [];

      if (!Array.isArray(preview_row.ShopData.ItemShopData)) {
        preview_row.ShopData.ItemShopData = [preview_row.ShopData.ItemShopData];
      }

      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'obj' implicitly has an 'any' type.
      preview_row.ShopData.ItemShopData.forEach(obj => {
        const qty_on_hand = obj.quantityOnHand === '0' ? '0' : obj.quantityOnHand || '';
        const unit_cost = obj.unitCost === '0' ? '0' : obj.unitCost || '';
        const reorder_point = obj.reorderPoint === '0' ? '0' : obj.reorderPoint || '';
        const reorder_level = obj.reorderLevel === '0' ? '0' : obj.reorderLevel || '';

        inventory_data.push(this._generateInventoryMarkup(obj.shopName, qty_on_hand, unit_cost));
        reorder_data.push(
          this._generateReorderValuesMarkup(obj.shopName, reorder_point, reorder_level)
        );
      });
      let item_shop_data = '';

      for (let i = 0; i < inventory_data.length; i++) {
        // @ts-expect-error ts-migrate(7005) FIXME: Variable 'inventory_data' implicitly has an 'any[]... Remove this comment to see the full error message
        item_shop_data += inventory_data[i];
      }

      item_shop_data += '<hr />';

      for (let j = 0; j < reorder_data.length; j++) {
        // @ts-expect-error ts-migrate(7005) FIXME: Variable 'reorder_data' implicitly has an 'any[]' ... Remove this comment to see the full error message
        item_shop_data += reorder_data[j];
      }

      $('#item-shop-data').append(item_shop_data);

      $("input[name='matrix']").val(
        $('<div>')
          .html(preview_row.MatrixDescription)
          .text()
      );
      $("input[name='attribute-1']").val(
        $('<div>')
          .html(preview_row.Attribute1)
          .text()
      );
      $("input[name='attribute-2']").val(
        $('<div>')
          .html(preview_row.Attribute2)
          .text()
      );
      $("input[name='attribute-3']").val(
        $('<div>')
          .html(preview_row.Attribute3)
          .text()
      );

      if (preview_row.Archive !== null) {
        const archived_str = this._booleanValueToDisplayableString(preview_row.Archive);
        $("input[name='archive']").val(archived_str);
      }

      if (typeof preview_row.MatrixAttributeSet !== 'undefined') {
        $("option[name='attribute-type']").htmlReplace(preview_row.MatrixAttributeSet);
      }

      if (typeof preview_row.Discountable !== 'undefined') {
        const discountable_str = this._booleanValueToDisplayableString(preview_row.Discountable);
        $("input[name='discountable']").val(discountable_str);
      }

      if (typeof preview_row.AddTags !== 'undefined') {
        let tags_str = '';

        if (preview_row.AddTags.Tag instanceof Array) {
          // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'elem' implicitly has an 'any' type.
          tags_str = preview_row.AddTags.Tag.map(elem => {
            return elem.name;
          }).join(', ');
        } else if (preview_row.AddTags.hasOwnProperty('Tag')) {
          tags_str = preview_row.AddTags.Tag.name;
        }

        $("input[name='tags']").val(tags_str);
      }

      if (typeof preview_row.ClearExistingTags !== 'undefined') {
        const clear_tags_str = this._booleanValueToDisplayableString(preview_row.ClearExistingTags);
        $("input[name='clear-tags']").val(clear_tags_str);
      }

      if (typeof preview_row.Serialized !== 'undefined') {
        const serialized_str = this._booleanValueToDisplayableString(preview_row.Serialized);
        $("input[name='serialized']").val(serialized_str);
      }

      if (typeof preview_row.PublishToEcom !== 'undefined') {
        const publish_to_ecom_str = this._booleanValueToDisplayableString(
          preview_row.PublishToEcom
        );
        $("input[name='publish-to-ecom']").val(publish_to_ecom_str);
      }

      if (typeof preview_row.Taxable !== 'undefined') {
        const taxable_str = this._booleanValueToDisplayableString(preview_row.Taxable);
        $("input[name='taxable']").val(taxable_str);
      }

      if (typeof preview_row.TaxClass !== 'undefined') {
        $("option[name='tax-class']").htmlReplace(preview_row.TaxClass);
      }

      if (typeof preview_row.ItemType !== 'undefined') {
        const item_type_str = this._itemTypeToDisplayableString(preview_row.ItemType);
        $("option[name='item-type']").htmlReplace(item_type_str);
      }

      $("textarea[name='note']").val(
        $('<div>')
          .html(preview_row.Note)
          .text()
      );

      if (typeof preview_row.DisplayNote !== 'undefined') {
        const display_note_str = this._booleanValueToDisplayableString(preview_row.DisplayNote);
        $("input[name='display-note']").val(display_note_str);
      }

      if (typeof preview_row.FeaturedImage !== 'undefined') {
        $("input[name='featured-image']").val(preview_row.FeaturedImage);
      }

      if (typeof preview_row.Images !== 'undefined') {
        if (typeof preview_row.Images.Image !== 'undefined') {
          let image_preview = '';
          const image_textarea = $("textarea[name='images']");
          const numPreviewImages = preview_row.Images.Image.length;

          if (!Array.isArray(preview_row.Images.Image)) {
            preview_row.Images.Image = [preview_row.Images.Image];
          }

          // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'image' implicitly has an 'any' type.
          preview_row.Images.Image.forEach((image, index) => {
            image_preview += image.filename;

            if (index !== numPreviewImages - 1) {
              image_preview += '\n';
            }
          });

          image_textarea.val(image_preview);
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          image_textarea.height((image_textarea.height() + 1) * numPreviewImages + 1);
        }
      }
    }

    $('#import-items').prop('disabled', false);
  };

  /**
   * Generates the HTML for price levels preview row data.
   *
   * @private
   */
  _generatePriceLevelMarkup: MerchantosItemImport['_generatePriceLevelMarkup'] = priceLevels => {
    let markup = "<div class='row'>";
    let direction = 'left';
    priceLevels.forEach(priceLevel => {
      markup +=
        `<div class="col6 cr-mb-4 ${direction}">` +
        `<span><span notranslate>${
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          priceLevel.name
        }</span></span>` +
        `<input type="text" value="${
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          priceLevel.value
        }" disabled />` +
        `</div>`;
      direction = direction == 'left' ? 'right' : 'left';
    });
    markup += '</div>';
    return markup;
  };

  /**
   * Generates the HTML for inventory preview row data.
   *
   * @private
   */
  _generateInventoryMarkup: MerchantosItemImport['_generateInventoryMarkup'] = (
    shop_name,
    qty_on_hand,
    unit_cost
  ) => {
    return (
      `${'<div class="row">' +
        '<div class="left">' +
        '<span>Quantity On Hand<span notranslate> - '}${shop_name}</span></span>` +
      `<input type="text" name="quantity-on-hand" value="${qty_on_hand}" disabled />` +
      `</div>` +
      `<div class="right">` +
      `<span>Unit Cost<span notranslate> - ${shop_name}</span></span>` +
      `<input type="text" class="money" name="unit-cost" value="${unit_cost}" disabled />` +
      `</div>` +
      `</div>`
    );
  };

  /**
   * Generates the HTML for reorder values preview row data.
   *
   * @private
   */
  _generateReorderValuesMarkup: MerchantosItemImport['_generateReorderValuesMarkup'] = (
    shop_name,
    reorder_point,
    reorder_level
  ) => {
    return (
      `${'<div class="row">' +
        '<div class="left">' +
        '<span>Reorder Point<span notranslate> - '}${shop_name}</span></span>` +
      `<input type="text" name="reorder-point" value="${reorder_point}" disabled />` +
      `</div>` +
      `<div class="right">` +
      `<span>Reorder Level<span notranslate> - ${shop_name}</span></span>` +
      `<input type="text" name="reorder-level" value="${reorder_level}" disabled />` +
      `</div>` +
      `</div>`
    );
  };

  /**
   * Checks current status of job queue and redirects page appropriately
   *
   * @private
   */
  _checkImportQueue: MerchantosItemImport['_checkImportQueue'] = () => {
    const url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}/ItemImport/${
      this.itemImportID
    }`;

    window.lsCloud.getJSONFromAPI(url).then(data => {
      const status = data.ItemImport.status;
      if (status === STATUS_QUEUED) {
        window.setTimeout(this._checkImportQueue, 1000);
      } else {
        this.job = data.Job;

        const current_url = window.location.href;
        const item_import_url = `name=${view_name}&form_name=view&id=${this.itemImportID}`;

        // Only redirect if the job's status changes while
        // we're on its queuing page
        if (
          current_url.indexOf(item_import_url) >= 0 &&
          $('#import-in-progress').not(':hidden').length > 0
        ) {
          if (status === STATUS_FAILURE || status === STATUS_SUCCESS) {
            // Refresh to load Results screen
            location.reload();
          } else if (status === STATUS_RUNNING) {
            this._showRunningImportScreen();
          }
        }
      }
    });
  };

  /**
   * Gets ItemImport object based on id in url
   *
   * @private
   */
  _getItemImportObj: MerchantosItemImport['_getItemImportObj'] = () => {
    const $deferred = $.Deferred();
    if (!this.itemImportID) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
      this.itemImportID = this.getItemImportIDFromURL();
    }

    if (this.itemImportID) {
      const url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}/ItemImport/${
        this.itemImportID
      }`;

      window.lsCloud.getJSONFromAPI(url).then(data => {
        this.itemImport = data.ItemImport;
        this.itemImportID = data.ItemImport.itemImportID;
        this.jobID = data.ItemImport.jobID;

        $deferred.resolve();
      });
    } else {
      $deferred.resolve();
    }

    return $deferred;
  };

  /**
   * Gets expected image object based on item_import_id
   *
   * @private
   */
  _getExpectedImageObj: MerchantosItemImport['_getExpectedImageObj'] = () => {
    const $deferred = $.Deferred();
    if (!this.itemImportID) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
      this.itemImportID = this.getItemImportIDFromURL();
    }

    if (this.itemImportID) {
      const url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}/ItemImport/${
        this.itemImportID
      }/ExpectedItemImages.json`;

      window.lsCloud.getJSONFromAPI(url).then(data => {
        this.expectedImageCount = data.ExpectedItemImages.ExpectedImages['@attributes'].count;

        $deferred.resolve();
      });
    } else {
      $deferred.resolve();
    }

    return $deferred;
  };

  /**
   * Displays image upload success screen and hides expected image listing
   *
   * @private
   */
  _showImageUploadSuccessScreen: MerchantosItemImport['_showImageUploadSuccessScreen'] = () => {
    $('#view_f_2').remove();
    $('.success-card').show();
    $('#import-images-button').prop('disabled', true);
    $('#view').css('border-bottom', 'none');
  };

  /**
   * Calls delete api to cancel import
   *
   * @private
   */
  _cancelImport: MerchantosItemImport['_cancelImport'] = () => {
    const $deferred = $.Deferred();

    if (this.itemImportID) {
      $.when(
        window.lsCloud.startServerJob(
          {
            url: `API/Account/${this.accountID}/ItemImport/${this.itemImportID}.json`,
            type: 'DELETE',
          },
          false
        )
      ).done(() => {
        $.when(this._checkForCanceledJob()).done(() => {
          $deferred.resolve();
        });
      });
    } else {
      $deferred.resolve();
    }
    return $deferred;
  };

  /**
   * Checks if current job status is canceled
   *
   * @private
   */
  _checkForCanceledJob: MerchantosItemImport['_checkForCanceledJob'] = () => {
    const $deferred = $.Deferred();

    setTimeout(() => {
      const url = `API/Account/${window.merchantos.session.getSystemCustomerID()}/ItemImport/${
        this.itemImportID
      }`;
      window.lsCloud.getJSONFromAPI(url).done(data => {
        if (data.ItemImport.status === STATUS_ARCHIVED) {
          $deferred.resolve();
        } else {
          this._checkForCanceledJob();
        }
      });
    }, 500);

    return $deferred;
  };

  /**
   * Gets job object based on job_id
   *
   * @private
   */
  _getJobObj: MerchantosItemImport['_getJobObj'] = () => {
    const $deferred = $.Deferred();

    if (this.jobID) {
      const url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}/Job/${
        this.jobID
      }`;

      window.lsCloud.getJSONFromAPI(url).then(data => {
        this.job = data.Job;

        $deferred.resolve();
      });
    } else {
      $deferred.resolve();
    }

    return $deferred;
  };

  /**
   * Converts booleans to strings to display on the preview screen.
   *
   * @private
   */
  _booleanValueToDisplayableString: MerchantosItemImport['_booleanValueToDisplayableString'] = val => {
    let ret = '';

    if (val === true || val === 'true') {
      ret = 'Yes';
    } else if (val === false || val === 'false') {
      ret = 'No';
    }

    return ret;
  };

  /**
   * Converts item type from csv to more readable value
   *
   * @private
   */
  _itemTypeToDisplayableString: MerchantosItemImport['_itemTypeToDisplayableString'] = val => {
    let ret = '';

    switch (val) {
      case 'default': // Fall through to single to match UI.
      case 'single':
        ret = 'Single';
        break;
      case 'non_inventory': // Both dash and underscore are accepted values.
      case 'non-inventory':
        ret = 'Non-Inventory';
        break;
      case 'serialized_assembly':
        ret = 'Serialized Assembly';
        break;
      case 'assembly':
        ret = 'Assembly';
        break;
      case 'serialized':
        ret = 'Serialized';
        break;
      case 'box':
        ret = 'Box';
        break;
      default:
        // In the unlikelihood of receiving nothing, we return single.
        ret = 'Single';
        break;
    }

    return ret;
  };

  /**
   * Outputs category tree string in proper format for Import Preview
   *
   * @private
   */
  _categoryToDisplayableString: MerchantosItemImport['_categoryToDisplayableString'] = previewRow => {
    let ret = '';

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (previewRow.Category) {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      ret += previewRow.Category;
    }

    for (let i = 1; i <= 9; i++) {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      if (previewRow[`Subcategory${i}`]) {
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        ret += ` / ${previewRow[`Subcategory${i}`]}`;
      } else {
        break;
      }
    }

    return ret;
  };
}

window.merchantos.item_import = new ItemImport();
